// extracted by mini-css-extract-plugin
export default {"modalOverlay":"fL-z","modalContent":"gL-z","header":"hL-z","close":"iL-z"};